// extracted by mini-css-extract-plugin
export default {"Card":"style_Card__LBz4g","rank":"style_rank__sDv-J","suit":"style_suit__9glv-","CardBack":"style_CardBack__92gxc"};